
import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import VideoTab from '../videoTab/videoTab.vue';
import FontContent from '../fontContent/fontContent';
import WordPronunciation from '../wordPronunciation/wordPronunciation';
import NumPronunciation from '../numPronunciation/numPronunciation';
import StyleContent from '../styleContent/styleContent';
import TextTemplateContent from '../TextTemplateContent/TextTemplateContent';
import { TabTypeMap } from '../../utils/constant';
import FontFaceObserver from 'fontfaceobserver';
import { Inject } from 'vue-property-decorator';
import { Prop, Watch } from 'vue-property-decorator'
import { judgeDeviceType } from '@/utils/device';
import { compareObjects, debouncedSaveArticle, fontNameEn } from '../../utils/utils';

/**components**/
@Component({
  components: {
    VideoTab,
    FontContent,
    StyleContent,
    WordPronunciation,
    NumPronunciation,
    TextTemplateContent
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class StylePopup extends Vue{
  @Prop({default: false})
  visible: boolean
  @Inject({from: 'triggerEditorSubtitle'})
  triggerEditorSubtitle
  @Prop({default: ''})
  scaleRatio: string
  rcTTSWordList = []
  state = new PageState();
  subtitlesText = ''; // 字幕内容
  oldSubtitlesText = ''; // 原始字幕内容
  show = false
  tabList = [
    {
      id: 0,
      title: '字体',
      component: 'FontContent',
    },
    {
      id: 1,
      title: '样式',
      component: 'StyleContent'
    },
    {
      id: 2,
      title: '文字发音',
      component: 'WordPronunciation'
    },
    {
      id: 3,
      title: '数字发音',
      component: 'NumPronunciation'
    },
    {
      id: 4,
      title: '文字模板',
      component: 'TextTemplateContent'
    }
  ];
  fontList = [];
  activeTab = this.tabList[0];
  activeFont = this.fontList[1] || {}
  subTitleParams: any = {}
  subTitleSourceParams: any = {source: ''}
  
  source = ''
  defaultHeight = 0
  newHeight = 0
  visualViewportHeight = 0
  scrollerHeight
  videoEditor: HTMLElement
  coverWrapper: HTMLElement
  styleContentHeight = '100%'
  oldSubtitleInfo = {}
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted() {
    this.getFontFamilyList()
    this.defaultHeight = window.innerHeight
    this.videoEditor = document.getElementsByClassName('videoEditor')[0] as HTMLElement;
    if (judgeDeviceType.isAndroid) {
      const innerHeight = window.innerHeight;
      window.addEventListener('resize', () => {
        const newInnerHeight = window.innerHeight;
        if (innerHeight > newInnerHeight) {
          // 键盘弹出事件处理 
          this.onFocus()    
        } else {
          // 键盘收起事件处理
         this.onBlur()
        }
      });
    }
  }
  @Watch('newHeight')
  listenNewHeight() {
    this.visualViewportHeight = Math.abs(this.newHeight - this.defaultHeight)
  }
  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (!val) {
      const compareList = compareObjects(this.oldSubtitleInfo, this.state.subtitleInfo)
      if (compareList.length > 0) {
        this.$bus.$emit(this.$EventBusKey.SAVE_DATA)
      }
     
    } else {
      if (this.source !== 'cover' && this.source !== 'shortPlay') {
        if (this.state.subtitleInfo.fontPercent) {
          this.$nextTick(() => {
            this.setFontPercent(this.state.subtitleInfo.fontPercent)
          })
        }
      }

      this.oldSubtitlesText = this.subtitlesText
      this.oldSubtitleInfo = JSON.parse(JSON.stringify(this.state.subtitleInfo))
    }
  }

  @Watch('state.operatingTextTemplate.id')
  listenOperatingTextTemplateId(val) {
    if (val === this.state.savedTextTemplate.id) {
      this.subtitlesText = this.state.savedTextTemplate.text
    } else {
      this.subtitlesText = ''
    }
  }

  @Watch('state.subtitleInfo.fontPercent')
  onFontResize() {
    if (this.state.subtitleInfo.fontPercent) {
      this.$nextTick(() => {
        this.setFontPercent(this.state.subtitleInfo.fontPercent)
      })
    }
  }

  setFontPercent(value){
    if (this.$refs.styleContentRef) {
      (this.$refs.styleContentRef as any).fontPercent = value
    }
  }

  // 字体初始化
  initFontFamily() {
    const { fontFamily } = this.state.subtitleInfo
    if (this.fontList.length === 0) {
      return
    }
    console.log('initFontStyleList-subtitleInfo', this.state.subtitleInfo)
    this.activeFont = this.fontList.find(item => item.nameEn === fontFamily) || this.fontList[0]
    this.state.subtitleInfo.fontFamily = this.activeFont.nameEn
    
    this.$bus.$emit('download-fontFamily')
  }

  activeTabType = null

  get handleTabList() {
    return this.tabList.filter(item => {
      return (
        this.activeTabType === TabTypeMap.EDIT_TEXT_TEMPLATE
          ? item.component === 'TextTemplateContent'
          : item.component !== 'TextTemplateContent'
      )
    })
  }

  /**
   * 设置参数
   * @param params
   */
  setParams(type, params) {
    this.activeTabType = type
    if (type === TabTypeMap.STYLE || type === TabTypeMap.EDITFONT) {
      this.activeTab = this.tabList[1]
    } else if (type === TabTypeMap.EDIT_TEXT_TEMPLATE) {
      this.activeTab = this.tabList[4]
    } else if (type === TabTypeMap.WORDPRON) {
      this.activeTab = this.tabList[2]
    } else if (type === TabTypeMap.NUMPRON) {
      this.activeTab = this.tabList[3]
    } else {
      this.activeTab = this.tabList[0]
    }
    if (params) {
      this.subtitlesText = params.text || ''
      this.oldSubtitlesText = params.text || ''
      if (params.source && (params.source === 'cover' || params.source === 'shortPlay')) {
        const index = this.tabList.findIndex(item => item.id === 2 || item.id === 3)
        if (index !== -1) {
          this.tabList.splice(2, this.tabList.length - 2)
        }
        this.subTitleSourceParams = params
        this.source = params.source
        this.$nextTick(() => {
          if (params?.fontPercent) this.setFontPercent(params.fontPercent);
          // 字体颜色选中
          if (this.$refs.styleContentRef) {
            (this.$refs.styleContentRef as any).activeColor = params.fontColour;
          }
          if(params.source === 'shortPlay') this.subTitleParams = params;
          // 字体选中
          if(params.fontFamily && this.fontList.length) {
            this.activeFont = this.fontList.find(item => item.nameEn === params.fontFamily) || this.fontList[0]
          }
        })
      } else if (params.source === 'text_template') {
        // 文字模板
        this.source = params.source
      } else {
        this.subTitleParams = {...this.state.subtitleInfo, ...params}
        this.source = ''
      }
      this.rcTTSWordList = params.rcttsWordList
      
    }
  }
  closePopup() {
    this.$emit('close')
  }

  /**
   * 输入内容变化
   */
  inputContent(text) {
    if (this.source === 'cover') {
      console.log('inputContent', this.subTitleSourceParams)
      const _subTitleParams = {...this.subTitleSourceParams, text: text}
      const type = this.activeTab.id === 0 ? TabTypeMap.FONT : TabTypeMap.EDITFONT
      this.triggerEditorSubtitle(_subTitleParams, type)
      this.$bus.$emit('input-subtitle', _subTitleParams, this.subTitleSourceParams.index)
    } else if (this.source === 'text_template') {
      this.state.operatingTextTemplate.text = text
    } else {
      debouncedSaveArticle(this)
      this.$emit('input', text)
    }
  }
  onTouchstart() {
    (this.$refs.inputRef as any).blur()
  }
  onFocus() {
    const ratioList = this.scaleRatio.split(':')
    let scrollTop = 150
    if (Number(ratioList[0]) > Number(ratioList[1])) {
      scrollTop = 100
    }
    if (judgeDeviceType.isAndroid) {
      this.styleContentHeight = 4 + 'rem'
      if (this.source === 'cover') {
        this.coverWrapper = document.getElementsByClassName('cover-picker-wrapper')[0] as HTMLElement;
        if (!this.coverWrapper) return
        this.coverWrapper.style.paddingBottom = '300px'
        let timer = setTimeout(() => {
          this.coverWrapper.scrollTo(0, scrollTop)
          clearTimeout(timer)
          timer = null
        }, 150)
      } else {
        let timer = setTimeout(() => {
          this.videoEditor.scrollTo(0, scrollTop)
          clearTimeout(timer)
          timer = null
        }, 150)
      }
      (this.$refs.fontStyleContentRef as HTMLElement).style.overflowY = 'hidden'
    }
   
    // console.log('onFocus', visualViewport.height)
    
    
    
  }
  onBlur() {
    // console.log('onBlur', window.innerHeight)
    // this.videoEditor.style.paddingTop = 0 + 'px'
    if ( this.coverWrapper) {
      this.coverWrapper.style.paddingBottom = '0px'
      this.coverWrapper.scrollTo(0, 0)
    }
   
    this.videoEditor.scrollTo(0, 0)
    this.styleContentHeight = '100%';
    (this.$refs.fontStyleContentRef as HTMLElement).style.overflowY = 'auto'
  }
  /**
   * 提交字幕
   */
  confirmSubtitle() {
    // if (!this.subtitlesText.trim()) {
    //   this.$toast({
    //     message: '请至少输入一个中文字符'
    //   })
    //   return
    // }
    // this.state.subtitleInfo.content = this.subtitlesText
    console.log('confirmSubtitle', this.activeTab)
    this.$emit('confirm', this.source)
  }
  /**
   * 切换tab
   * @param tabIndex 
   */
  changeTab(tab) {
    this.activeTab = tab
  }
  /**
   * 选择当前字体
   * @param font
   */
  async selectFont(fontItem) {
    if(fontItem.downStatus !== 0){
      // 下载字体
      this.downloadFont(fontItem)
      return
    }
    this.activeFont = fontItem
    if (this.source === 'cover') {
      const _subTitleParams = {...this.subTitleSourceParams, fontFamily: fontItem.nameEn}
      this.triggerEditorSubtitle(_subTitleParams, TabTypeMap.FONT)
      this.$bus.$emit('input-subtitle', _subTitleParams)
      
    } else {
      this.state.subtitleInfo.fontFamily = fontItem.nameEn
      debouncedSaveArticle(this)
    }
  }
  /**
   * 下载字体
   * @param font
   */
  downloadFont(font) {
    const fontIndex = this.fontList.findIndex(item => item.id === font.id)
    const fontItem = this.fontList[fontIndex]
    fontItem.downStatus = 2
    this.downloadFontFamily(fontItem).then(() => {
      fontItem.downStatus = 0
      localStorage.setItem('fontFamilyList', JSON.stringify(this.fontList))
      this.$bus.$emit('download-fontFamily')
    }).catch(e => {
      fontItem.downStatus = 1
      console.log('下载字体失败，请稍后重试', e, e?.message)
      this.$toast('下载字体失败，请稍后重试')
    }).finally(() => {
      this.$http('downloadRecord', {
        fontId: fontItem.id
      })
    })
  }
  getFontFamilyList() {
    this.$http('getFontList').then((res) => {
      if (res.code === 200) {
        this.fontList = res.data.map((item, index) => {
          item['downStatus'] = index === 0 ? 0 : 1
          return item
        })
        const fontFamilyStr = localStorage.getItem('fontFamilyList')
        if (fontFamilyStr) {
          const _fontList = JSON.parse(fontFamilyStr)
          this.fontList.forEach((item) => {
            const _fontItem = _fontList.find(fontItem => fontItem.id === item.id)
            if (_fontItem) {
              item.downStatus = _fontItem.downStatus
            }
          })
        }

        const downList = this.fontList.filter((item) => item.nameEn === "Douyin Sans" || item.id === 20 || item.downStatus !== 1)
        console.log('fontList', downList)
        this.downloadAllFontFamily(downList).then((res)=>{
          res.forEach(({status, fontItem})=>{
            fontItem.downStatus = status === 'success' ? 0: 1
          })
          this.initFontFamily()
        })
      }
    })
  }
  downloadAllFontFamily(list) {
    return Promise.all(list.map(fontItem => {
      return this.downloadFontFamily(fontItem).then(() => {
        return { status: 'success', fontItem }
      }).catch(error => {
        return { status: 'failed', fontItem, error }
      })
    }))
  }
  downloadFontFamily(fontItem) {
    // 创建一个新的样式元素
    const styleElement: HTMLStyleElement = document.createElement('style');
    let nameEn = fontItem.nameEn
    nameEn = fontNameEn(nameEn)
    // 定义要添加到样式表中的CSS规则
    const cssRule = `@font-face { font-family: ${nameEn}; src: url(${fontItem.url}); }`;

    // 将CSS规则添加到样式元素中
    styleElement.appendChild(document.createTextNode(cssRule));

    // 将样式元素添加到文档头部或其他需要应用该字体的位置
    document.head.appendChild(styleElement);

    const font = new FontFaceObserver(nameEn)
    return font.load(null, 20000)
  }

	/****************************** 文字模板 ******************************/

	// 当前的文字模板
	get operatingTextTemplateItem() {
		let textTemplate = {}
		this.state.defaultTextTemplateList.forEach(item => {
			if (item.id === this.state.operatingTextTemplate.id) {
				textTemplate = item
			}
		})
		return textTemplate
	}
}